import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const StockAPI = createApi({
    reducerPath: "StockAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        addStocks: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/products/add-attributes/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
        updateStock: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/products/edit-attributes/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getStockbyId: builder.query({
            query: (id) => `admin/products/get-attributes/${id}`,
        }),
        StoreProductType: builder.mutation({
            query: (formData) => ({
                url: `admin/product-type`,
                method: "POST",
                body: formData,
            }),
        }),
        // getVarientsbyCategoryId: builder.query({
        //     query: (id) => `variants/variants-by-product/${id}`,
        // }),

        getVarientsbyCategoryId: builder.query({
            query: () => `/variants`,
        }),

        getVariantbyProductId: builder.query({
            query: (productId) => `variants/variants-by-product/${productId}`,
        }),

        storeVariantbyProductId: builder.mutation({
            query: ({ id, formattedData }) => ({
                url: `admin/variants_stock/products/${id}/variants`,
                method: "POST",
                body: formattedData,
            }),
        }),

        assignVariantsbyProduct: builder.query({
            query: (productId) => `variants/variants-by-product/${productId}`,
        }),

        StoreVariantProduct: builder.mutation({
            query: ({ id, formattedData }) => ({
                url: `admin/variants_stock/products/${id}/variants`,
                method: "POST",
                body: formattedData,
            }),
        }),
        getVariantStock: builder.query({
            query: (id) => `admin/variants_stock/products/${id}/variants`,
        }),
        bulkUpdateVarientStock :builder.mutation({
            query: ({ id, formattedData }) => ({
                url: `admin/variants_stock/products/${id}/variants-update`,
                method: "POST",
                body: formattedData,
            }),
        }),

        assignBulkVariantsbyProduct:builder.mutation({
            query: (formattedData) => ({
                url: `admin/products/assign-variants-product`,
                method: "POST",
                body: formattedData,
            }),
        }),
        updateVariantStatus: builder.mutation({
            query: (formData) => ({
                url: "admin/filters/change-status",
                method: "PATCH",
                body: formData,
            }),
        }),

    }),
});

export const { useAddStocksMutation, useUpdateStockMutation, useGetStockbyIdQuery, useStoreProductTypeMutation, useGetVarientsbyCategoryIdQuery, useStoreVariantProductMutation, useGetVariantStockQuery, useBulkUpdateVarientStockMutation , useGetVariantbyProductIdQuery, useStoreVariantbyProductIdMutation, useAssignBulkVariantsbyProductMutation, useUpdateVariantStatusMutation} = StockAPI;
